(() => {
  const body = document.body;

  // Only run on homepage
  if (!body.classList.contains('template-index')) return;

  const threshold = 10; // px until we consider it "scrolled"
  let ticking = false;

  const update = () => {
    const scrolled = window.scrollY > threshold;
    body.classList.toggle('header-scrolled', scrolled);
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  update(); // run once on load
})();
